module.exports = __webpack_public_path__ + "img/palm2_12.d7357a9a.png";